// extracted by mini-css-extract-plugin
export var cartContainer = "_ng-4";
export var gray = "_ng-1";
export var itemContainer = "_ng-2";
export var itemDetails = "_ng-3";
export var strong = "_ng-0";